import { withStyles } from '@material-ui/core/styles';
import Confirm from './Confirm';
import styles from './Confirm.styles';

export default withStyles(styles)(Confirm);
